import {Button} from "@mui/material";
import AddBoxIcon from '@mui/icons-material/AddBox';

export const AddEventButton = (props) => {
    let href = "/event/edit/new"
    if (props.date) {
        href = href + "?date=" + props.date;
    }
    if (props.venueKey) {
        href = href + "?venueKey=" + props.venueKey;
    }
    return <Button startIcon={<AddBoxIcon />} size={"small"} href={href}>
        New Event
    </Button>
}

export default AddEventButton;